import $ from 'jquery';
import _ from 'underscore';
import { track } from 'util/analytics';
import {
  $body,
  $window,
  jqGetElemByCmpName,
  jqGetElemById,
  isMobile,
  userIsAuthenticated,
  jqOffOn,
  isBrilliantPremium,
} from 'util/global';
import { Anchors, crop } from 'util/ui';
import * as urls from 'util/urls';
import { INTERACTION_TYPES } from 'util/constants';
import { errorModalHandler } from 'app/error_modal';
import { initGenericControllers } from 'app/generic_controllers';
import { twinklingStars } from 'app/paid';

const Practice = {};

/**
 * Practice subtopic controller.
 * @param {JQuery} $container
 */
Practice.subtopic = function ($container) {
  var data = $container.data();
  var $subtopics = $('.prac-subtopic');
  var $initialSubtopic = $subtopics.filter('.expanded');

  if ($initialSubtopic.length) {
    _.defer(function () {
      Anchors.scrollToTarget($initialSubtopic);
    });
  }

  $container.find('.prac-subtopic .trigger').on('click', function () {
    var $subtopic = $(this).parents('.prac-subtopic');
    $subtopic.toggleClass('expanded');

    if ($subtopic.hasClass('expanded')) {
      var subtopicSlug = $subtopic.data('subtopic-slug');
      var url = window.location.pathname + '?subtopic=' + subtopicSlug;
      var state = {
        subtopic: subtopicSlug,
      };
      try {
        window.history.replaceState(state, '', url);
      } catch (e) {}
    } else {
      try {
        window.history.replaceState({}, '', window.location.pathname);
      } catch (e) {}
    }
  });
};

/**
 * Filters the chapter's view to quizzes or wikis
 * @param {JQuery} $container
 */
Practice.quizWikiFilter = function ($container) {
  var $btnGroup = $container.find('.btn-group, .btn-tabs'),
    $btns = $btnGroup.children(),
    activeClass = 'active',
    allTypes = '';

  $btns.each(function () {
    allTypes += $(this).data('type') + ' ';
  });

  $btns.on('click', function () {
    var $this = $(this),
      type = $this.data('type');

    if (!$this.hasClass(activeClass)) {
      $btns.removeClass(activeClass);
      $this.addClass(activeClass);
      $container.removeClass(allTypes).addClass(type);
    }
  });
};

/**
 * Track clicks on exploration topics and chapters coming soon
 * @param {JQuery} $trigger
 */
Practice.trackExplorationsComingSoon = function ($trigger) {
  var data = $trigger.data();
  var topicSlug = data.topicSlug;
  var chapterSlug = data.chapterSlug;
  var trackingElementId;
  var trackingTarget;

  if (topicSlug) {
    trackingElementId = 'clicked_exploration_topic_coming_soon';
    trackingTarget = topicSlug;
  } else {
    trackingElementId = 'clicked_exploration_chapter_coming_soon';
    trackingTarget = chapterSlug;
  }

  $trigger.on('click', () => {
    track('ui', {
      action: 'click',
      element_type: 'link',
      element_id: trackingElementId,
      target: trackingTarget,
    });
  });
};

/**
 * Masonry-style layout for the topic wiki listing section
 * @param {JQuery} $container
 */
Practice.wikiListing = function ($container) {
  _.defer(function () {
    var currentHeight = $container.height();
    while (
      $container.width() < $container[0].scrollWidth ||
      $container.height() < $container[0].scrollHeight
    ) {
      currentHeight += 100;
      $container.css({
        height: currentHeight,
      });
    }
  });
};

/**
 * Handle the course coming soon form
 * @param {JQuery} $container
 */
Practice.notifyComingSoon = function ($container) {
  var $form = $container.find('form');
  var submitting = false;

  var handleSubmit = function () {
    if (submitting === false) {
      submitting = true;
      $container.removeClass('with-form');
      $.post($form.prop('action'))
        .fail(errorModalHandler)
        .fail(() => {
          submitting = false;
          $container.addClass('with-form');
        });
    }
  };

  $form.on('submit', function (e) {
    e.preventDefault();
    handleSubmit();
  });

  $container.on('click', handleSubmit);
};

/**
 * Share/actions menu for quiz problems and panes
 * @param {JQuery} $dropup
 */
Practice.quizSidebarDropup = $dropup => {
  const $quizSidebar = $('.course-quiz-sidebar');
  const $codexToggleBtns = $('.codex-expand-toggle');

  // make sure dropup is not overlapping with quiz content
  $dropup
    .on('open', () => {
      $codexToggleBtns.filter('.active').click();
      $quizSidebar.addClass('above-quiz-content');
    })
    .on('close', () => {
      $quizSidebar.removeClass('above-quiz-content');
    });
};

vkey.explorations_chapter_paywall = function (action, action_key) {
  vkey.handle(action, action_key);
};

/**
 * Handles the save for later button (looks like a bookmark)
 * @param {JQuery} $form - form that toggles if a solvable / pane has been saved
 */
Practice.saveForLater = $form => {
  const $button = $form.find('button');
  const $modal = $form.parent().find('#first-time-save-modal');

  const toggleButtonHover = () => {
    if ($button.hasClass('saved')) {
      $button
        .on('mouseenter', () => {
          $button.find('b').html('Remove');
        })
        .on('mouseleave', () => {
          $button.find('b').html('Saved');
        });
    } else {
      $button.off('mouseenter mouseleave');
    }
  };
  toggleButtonHover();
  $button.on('click', e => {
    e.preventDefault();
    $.post($form.attr('action'), $form.serialize(), response => {
      $button.toggleClass('saved');
      toggleButtonHover();
      if (response.saved) {
        $button.html('<b>Saved</b>');
        $form.prop('form_action').value = 'unsave';
      } else {
        $button.html('Save');
        $form.prop('form_action').value = 'save';
      }
      if (response.show_first_time_modal) {
        $modal.modal();
      }
    });
  });
};
module.exports = Practice;
